import { Equalizer } from '@mui/icons-material'
import React from 'react'
import { pointsText } from 'utils/functions'

const BgcScoreExpansibleTitle = ({ finalScore }) => (
  <span style={{ display: 'flex', alignItems: 'center' }}>
    <Equalizer fontSize="small" style={{ marginRight: '0.4rem', paddingBottom: '0.2rem' }} />
    {`Score do Background Check: ${pointsText(finalScore)}`}
  </span>
)

export default BgcScoreExpansibleTitle
